import React, { useEffect, useRef } from 'react';
import { Users, Calendar, Award, Heart } from 'lucide-react';
import { useTranslation } from 'react-i18next';
import { gsap } from 'gsap';
import { ScrollTrigger } from 'gsap/ScrollTrigger';
import './Stats.css';

if (typeof window !== 'undefined') {
    gsap.registerPlugin(ScrollTrigger);
}

const Stats = () => {
    const { t } = useTranslation();
    const sectionRef = useRef(null);
    const statsRef = useRef(null);

    const stats = [
        { icon: Users, value: '1000+', labelKey: 'stats.items.patients', color: '#2563eb' },
        { icon: Calendar, value: '15+', labelKey: 'stats.items.experience', color: '#14b8a6' },
        { icon: Award, value: '2', labelKey: 'stats.items.doctors', color: '#8b5cf6' },
        { icon: Heart, value: '100%', labelKey: 'stats.items.satisfaction', color: '#ef4444' },
    ];

    useEffect(() => {
        if (statsRef.current) {
            const statElements = statsRef.current.children;
            Array.from(statElements).forEach((stat, index) => {
                const valueElement = stat.querySelector('.stat-value');
                const finalValue = valueElement.textContent;

                // Animate counter
                const animateCounter = (element, finalValue) => {
                    const isPercentage = finalValue.includes('%');
                    const isPlus = finalValue.includes('+');
                    const numValue = parseInt(finalValue.replace(/[^0-9]/g, ''));

                    gsap.fromTo(
                        { value: 0 },
                        {
                            value: numValue,
                            duration: 2,
                            ease: 'power2.out',
                            scrollTrigger: {
                                trigger: stat,
                                start: 'top 85%',
                                toggleActions: 'play none none none',
                            },
                            onUpdate: function () {
                                const currentValue = Math.floor(this.targets()[0].value);
                                let displayValue = currentValue.toString();
                                if (isPercentage) displayValue += '%';
                                if (isPlus) displayValue += '+';
                                element.textContent = displayValue;
                            },
                        }
                    );
                };

                // Animate stat card
                gsap.fromTo(
                    stat,
                    { opacity: 0, y: 50, scale: 0.9 },
                    {
                        opacity: 1,
                        y: 0,
                        scale: 1,
                        duration: 0.8,
                        ease: 'power3.out',
                        delay: index * 0.15,
                        scrollTrigger: {
                            trigger: stat,
                            start: 'top 85%',
                            toggleActions: 'play none none none',
                        },
                        onComplete: () => {
                            if (valueElement) {
                                // animateCounter(valueElement, finalValue);
                            }
                        },
                    }
                );

                // Hover effect
                stat.addEventListener('mouseenter', () => {
                    gsap.to(stat, {
                        scale: 1.05,
                        y: -10,
                        duration: 0.3,
                        ease: 'power2.out',
                    });
                });

                stat.addEventListener('mouseleave', () => {
                    gsap.to(stat, {
                        scale: 1,
                        y: 0,
                        duration: 0.3,
                        ease: 'power2.out',
                    });
                });
            });
        }

        return () => {
            ScrollTrigger.getAll().forEach((trigger) => {
                if (sectionRef.current && trigger.vars.trigger === sectionRef.current) {
                    trigger.kill();
                }
            });
        };
    }, []);

    return (
        <section ref={sectionRef} className="stats">
            <div className="stats-container">
                <div ref={statsRef} className="stats-grid">
                    {stats.map((stat, index) => {
                        const IconComponent = stat.icon;
                        return (
                            <div key={index} className="stat-card">
                                <div className="stat-icon-wrapper" style={{ background: `${stat.color}15` }}>
                                    <IconComponent size={32} style={{ color: stat.color }} />
                                </div>
                                <div className="stat-value">{stat.value}</div>
                                <div className="stat-label">{t(stat.labelKey)}</div>
                            </div>
                        );
                    })}
                </div>
            </div>
        </section>
    );
};

export default Stats;

